/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import times from 'lodash/times';

import { Divider, Grid, Skeleton, Typography, Typography2 } from '@coursera/cds-core';

const styles = {
  divider: css`
    margin: var(--cds-spacing-200) 0;
  `,
  nameWrapper: css`
    flex-grow: 1;
    flex-shrink: 0;
  `,
  socialLinks: css`
    list-style: none;
    font-size: var(--cds-font-size-175);

    li {
      max-width: 60%;
    }
  `,
};

const ArticleAuthorPlaceholder = () => {
  return (
    <Grid container spacing={16}>
      <Grid item xs="auto">
        <Skeleton variant="circle" width={200} height={200} />
      </Grid>
      <Grid item css={styles.nameWrapper}>
        <Typography variant="h1semibold">
          <Skeleton />
        </Typography>
        <Typography variant="h2">
          <Skeleton />
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3} component="ul" css={styles.socialLinks}>
        {times(2).map((item) => {
          return (
            <li key={item}>
              <Skeleton />
            </li>
          );
        })}
      </Grid>
      <Grid item xs={12}>
        <Divider css={styles.divider} />
        <Typography variant="h2semibold">
          <Skeleton />
        </Typography>
        <Typography2 component="p" variant="bodyPrimary">
          <Skeleton />
          <Skeleton />
        </Typography2>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default ArticleAuthorPlaceholder;
